// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '52b6c9bc-20be-4667-9360-873ea0dce124',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 7,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'FARM HOUSE',
        atlas: 'diorama_4',
        reward: {
          'Coin': 100,
          'BoosterUndo': 1,
        }
      }
    },
    {
      id: '1260cfdb-ba70-4c99-805d-4d1e56f95688',
      type: 'Sprite',
      name: 'barnShadow',
      className: '',
      x: -131,
      y: -241,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Barn_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '723f2b09-a8bd-4205-9a3a-9148b4e27a02',
      type: 'Sprite',
      name: 'barn',
      className: '',
      x: -134,
      y: -279,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Barn',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 800,
        order: 4
      }
    },
    {
      id: 'c3672423-eafa-40db-9584-a1a2589dc6ca',
      type: 'Sprite',
      name: 'coopShadow',
      className: '',
      x: 55,
      y: -301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Chickens_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'e7f1f1f6-9729-4c9f-ad00-5926ac2a9028',
      type: 'Sprite',
      name: 'coop',
      className: '',
      x: 50,
      y: -328,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Chickens',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 700,
        order: 3
      }
    },
    {
      id: 'd6461b47-f0eb-4cb9-9d34-01c5d09c7996',
      type: 'Sprite',
      name: 'cropsShadow',
      className: '',
      x: -10,
      y: -339,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Crops_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '88dbac98-6410-4cd8-9496-f75b45b3cd74',
      type: 'Sprite',
      name: 'crops',
      className: '',
      x: -29,
      y: -368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Crops',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 1
      }
    },
    {
      id: '975e22ab-06ac-4104-a4b8-14f7ec514e4b',
      type: 'Sprite',
      name: 'sheepShadow',
      className: '',
      x: 41,
      y: -160,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Sheeps_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ee99fe6d-1145-4dbb-b303-8a51ce2ed1ce',
      type: 'Sprite',
      name: 'sheep',
      className: '',
      x: 37,
      y: -172,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Sheeps',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 900,
        order: 5
      }
    },
    {
      id: '12b08e82-16d4-4e37-9537-71182ededb9d',
      type: 'Sprite',
      name: 'tractorShadow',
      className: '',
      x: 145,
      y: -226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Tractor_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '37624a16-91ff-4800-a1d2-e46b368e5ff2',
      type: 'Sprite',
      name: 'tractor',
      className: '',
      x: 138,
      y: -256,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Tractor',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 600,
        order: 2
      }
    },
    {
      id: '6861f134-0f34-4806-bf6f-cda734d64e51',
      type: 'Sprite',
      name: 'dogShadow',
      className: '',
      x: -110,
      y: -123,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Dog_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '8ee5c301-7f08-4ac6-9d1e-a5c3ed82e2cc',
      type: 'Sprite',
      name: 'dog',
      className: '',
      x: -109,
      y: -139,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Dog',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1000,
        order: 6
      }
    },
    {
      id: '843de633-f0a9-40df-ab1d-f684f4600b03',
      type: 'Sprite',
      name: 'planeShadow',
      className: '',
      x: -85,
      y: -488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Plane_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '9d2539d1-2e84-4112-a6d5-5cdc6ad95c2d',
      type: 'Sprite',
      name: 'plane',
      className: '',
      x: -77,
      y: -516,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_4_Plane',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1000,
        order: 7
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_4 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  barnShadow!: Sprite;
  barn!: Sprite & { data: typeof raw['list'][3]['data'] };
  coopShadow!: Sprite;
  coop!: Sprite & { data: typeof raw['list'][5]['data'] };
  cropsShadow!: Sprite;
  crops!: Sprite & { data: typeof raw['list'][7]['data'] };
  sheepShadow!: Sprite;
  sheep!: Sprite & { data: typeof raw['list'][9]['data'] };
  tractorShadow!: Sprite;
  tractor!: Sprite & { data: typeof raw['list'][11]['data'] };
  dogShadow!: Sprite;
  dog!: Sprite & { data: typeof raw['list'][13]['data'] };
  planeShadow!: Sprite;
  plane!: Sprite & { data: typeof raw['list'][15]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
